import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CommonModule as AppCommonModule} from '@common/common.module';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {LegalPageComponent} from './legal-page.component';
import {NgLetModule} from '../../../directives/ngLet';

@NgModule({
	imports: [
		RouterModule.forChild([{
			path: '',
			component: LegalPageComponent,
		}]),
		CommonModule,
		AppCommonModule,
		NgLetModule,
		TranslateModule.forChild()
	],
	declarations: [LegalPageComponent],
	exports: [LegalPageComponent],
})
export class LegalPageModule {
}
